/** I-10 observations unprojected from website/src/lib/basemap/socal-az.ts.
 * © OpenStreetMap contributors, ODbL 1.0: https://www.openstreetmap.org/copyright
 * Preserve the marketing route clock and its sparse desert observations.
 */
export const I10_OBSERVATIONS = [
  {
    "minute": 370,
    "lat": 33.766145,
    "lng": -118.218,
    "checkpoint": 0
  },
  {
    "minute": 383,
    "lat": 33.871823,
    "lng": -118.194
  },
  {
    "minute": 395,
    "lat": 33.914655,
    "lng": -118.1052
  },
  {
    "minute": 415,
    "lat": 34.064895,
    "lng": -117.9978
  },
  {
    "minute": 427,
    "lat": 34.071356,
    "lng": -117.8694
  },
  {
    "minute": 444,
    "lat": 34.081792,
    "lng": -117.6996
  },
  {
    "minute": 455,
    "lat": 34.06738,
    "lng": -117.5844,
    "checkpoint": 1
  },
  {
    "minute": 472,
    "lat": 34.063404,
    "lng": -117.2904
  },
  {
    "minute": 495,
    "lat": 33.9276,
    "lng": -116.9814
  },
  {
    "minute": 502,
    "lat": 33.924115,
    "lng": -116.862
  },
  {
    "minute": 520,
    "lat": 33.905194,
    "lng": -116.5584
  },
  {
    "minute": 538,
    "lat": 33.766644,
    "lng": -116.3226
  },
  {
    "minute": 545,
    "lat": 33.730724,
    "lng": -116.208,
    "checkpoint": 2
  },
  {
    "minute": 556,
    "lat": 33.679312,
    "lng": -115.9968
  },
  {
    "minute": 572,
    "lat": 33.66583,
    "lng": -115.6848
  },
  {
    "minute": 600,
    "lat": 33.644355,
    "lng": -115.116
  },
  {
    "minute": 620,
    "lat": 33.609383,
    "lng": -114.7242
  },
  {
    "minute": 630,
    "lat": 33.603386,
    "lng": -114.5256,
    "checkpoint": 3
  },
  {
    "minute": 654,
    "lat": 33.664832,
    "lng": -114.2028
  },
  {
    "minute": 667,
    "lat": 33.663333,
    "lng": -114.0258
  },
  {
    "minute": 729,
    "lat": 33.541397,
    "lng": -113.1726
  },
  {
    "minute": 745,
    "lat": 33.499379,
    "lng": -112.9458
  },
  {
    "minute": 793,
    "lat": 33.460845,
    "lng": -112.2954
  },
  {
    "minute": 805,
    "lat": 33.462346,
    "lng": -112.1322
  },
  {
    "minute": 815,
    "lat": 33.423796,
    "lng": -112.0236
  },
  {
    "minute": 825,
    "lat": 33.344638,
    "lng": -111.9726,
    "checkpoint": 4
  }
] as const;
